module.exports = __webpack_public_path__ + "static/media/three_dots_vertical.cf002af1.svg";